<template>
    <div>
        <!-- <div style="height: 65px;"></div> -->
        <!-- top -->
        <div class="container-top">
            <div class="banner">
                <div class="left">
                    <img src="../../assets/news-left.png" alt="">
                </div>

                <div class="right">
                    <div class="time">
                        <img src="../../assets/news.png" />
                        <span>{{ time }}</span>
                    </div>
                    <div class="info">
                        <h1>企业级AI定制解决方案：安全与隐私保护在开发中不可忽视的关键因素</h1>
                        <p>从数据加密到合规审计，揭秘企业级AI定制开发中的隐私安全防护全流程</p>
                    </div>
                    <div class="detail">
                        查看详情
                    </div>
                </div>
            </div>
        </div>
        <!-- essay tabs -->
        <div class="essay">
            <div class="tabs">
                <div class="tab-item " :class="tab == 1 ? 'tab-item-active' : null" @click="tab = 1">无忧动态</div>
                <div class="tab-item" :class="tab == 2 ? 'tab-item-active' : null" @click="tab = 2">资源分享</div>
            </div>
        </div>
        <!-- essay list -->
        <div class="essay-company" v-if="tab == 1">
            <div class="list">
                <div class="list-item">
                    <div class="left">
                        <img src="../../assets/essay.png" alt="">
                    </div>
                    <div class="right">
                        <h1>无忧软件与安信瞳联手，打造智能穿戴视力教程小程序/app《爱翻转》</h1>
                        <p>蓝牙通信，视力检测，训练功能</p>
                    </div>
                </div>
                <div class="list-item">
                    <div class="left">
                        <img src="../../assets/essay.png" alt="">
                    </div>
                    <div class="right">
                        <h1>无忧软件与信丰伟业联手，打造无线路由器模拟器系统</h1>
                        <p>兼容多国语言，实现路由器全部功能</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="essay-company" v-else>
            没有更多数据了
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    components: {},
    data() {
        return {
            time: new Date,
            tab: 1
        }
    },
    watch: {},
    created() { },
    mounted() { },
    methods: {},
}

</script>
<style>
html,
body {
    width: 100%;
    height: 100%;
    background-color: #f6faff !important;
}
</style>
<style lang='scss' scoped>
@media screen and (max-width: 768px) {
    .container-top {
        margin-top: 0px !important;
    }

    .essay-company {
        width: 90% !important;

        .list {
            .list-item {
                flex-wrap: wrap !important;

                .left {
                    width: 100%;

                    img {
                        width: 100%;
                    }
                }
            }
        }
    }

    .banner {
        flex-wrap: wrap;
        width: 100% !important;

        .left {
            width: 100% !important;

            img {
                width: 100%;
                padding: 10px;
                border: none !important;
            }
        }

        .right {
            width: 100% !important;

            .detail {
                padding: 0px 20px;
            }

            .info {
                h1 {
                    padding: 0px 20px;
                    width: 100% !important;
                    font-size: 18px !important;
                }

                p {
                    padding: 0px 20px !important;
                    line-height: 20px !important;
                }
            }

            .time {
                padding: 0px 20px;
                font-size: 12px;
            }
        }
    }


}

.essay-company {
    width: 70%;
    margin: 0px auto;

    .list {
        .list-item {
            display: flex;
            margin: 10px 0px;
            justify-content: center;
            align-content: center;
            align-items: center;
            text-align: start;
            background: #fafbfc;
            border-radius: 50px;
            border: 5px #fff solid;

            .left {
                img {
                    height: 200px;
                    border-radius: 50px;
                }
            }

            .right {
                flex-grow: 1;
                margin-left: 20px;

                h1 {
                    font-size: 18px;
                    font-weight: bold;
                    color: #2956ff;
                }

                p {
                    font-size: 12px;
                }
            }
        }
    }
}

.essay {
    width: 70%;
    margin: 50px auto;
    cursor: pointer;

    .tabs {
        // width: 50%;
        background-color: #fff;
        border-radius: 50px;
        display: flex;
        justify-content: space-between;
        margin: 0px auto;
        overflow: hidden;
        height: 40px;
        line-height: 40px;

        .tab-item {
            width: 50%;
            font-size: 18px;
            font-weight: bold;
            color: black;
        }

        .tab-item-active {
            background-color: #2956ff;
            border-radius: 50px;
            color: #fff;
        }
    }
}

.container-top {
    background: linear-gradient(90deg, #c6dcfd 0%, #e6eefe 100%);
    overflow: hidden;
    margin-top: 50px;

    .banner {
        justify-content: center;
        display: flex;
        margin: 0px auto;
        width: 70%;
        padding: 100px 0px;

        .left {
            width: 35%;

            img {
                height: 300px;
                border: 10px #dfecff solid;
                border-radius: 30px;
            }
        }

        .right {
            width: 40%;
            text-align: start;

            .detail {
                text-align: start;
            }

            .detail {
                margin-top: 80px;
                font-size: 18px;
                color: #2956ff;
            }

            .info {
                h1 {
                    font-size: 30px;
                    font-weight: bold;
                    width: 500px;
                    margin: 20px 0px;
                }

                p {
                    font-size: 13px;
                    line-height: 0px;
                    color: #939bae;
                    letter-spacing: 1px;
                    margin-bottom: 20px;
                }
            }

            .time {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-top: 20px;

                img {
                    height: 30px;
                }
            }
        }
    }
}
</style>